import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User } from '@/types';

/**
 * Состояние аутентификации
 */
interface AuthState {
  user: User | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, accessToken: string, refreshToken: string, rememberMe?: boolean) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  logout: () => void;
}

/**
 * Store для управления аутентификацией
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,

      /**
       * Установить данные аутентификации
       */
      setAuth: (user, accessToken, refreshToken, rememberMe = true) => {
        const storage = rememberMe ? localStorage : sessionStorage;
        storage.setItem('access_token', accessToken);
        storage.setItem('refresh_token', refreshToken);
        document.cookie = 'is_authenticated=1; path=/; SameSite=Lax; max-age=2592000'; // 30 days
        set({ user, accessToken, refreshToken, isAuthenticated: true });
      },

      /**
       * Установить только токены (без данных пользователя)
       */
      setTokens: (accessToken, refreshToken) => {
        localStorage.setItem('access_token', accessToken);
        localStorage.setItem('refresh_token', refreshToken);
        document.cookie = 'is_authenticated=1; path=/; SameSite=Lax; max-age=2592000';
        set({ accessToken, refreshToken, isAuthenticated: true });
      },

      /**
       * Выход из системы
       */
      logout: () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('refresh_token');
        document.cookie = 'is_authenticated=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
        set({ user: null, accessToken: null, refreshToken: null, isAuthenticated: false });
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
